export interface ILog {
	id: string | number;
	msg: string;
	showMessage: boolean;
	date: Date;
}
